// Redirect if hostname ends with a trailing dot
const [hostname, port] = location.host.split(':');
if (hostname.endsWith('.')) {
  const newHost = hostname.slice(0, -1) + (port ? `:${port}` : '');
  const newUrl = `${window.location.protocol}//${newHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(newUrl);
}

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
